module.exports = __webpack_public_path__ + "img/ic_xls_download.6eacdc68.png";